import {
  Component,
  OnInit,
  ViewChild,
  HostListener,
  ElementRef,
} from '@angular/core';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { EventInput, Calendar, EventUi } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import resourceDayGridPlugin from '@fullcalendar/resource-daygrid';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HelpersService } from '../../../../services/helpers.service';
import { PartnerService } from '../../../../services/partner.service';
import { CyclistService } from '../../../../services/cyclist.service';
import { ChecklistService } from '../../../../services/checklist.service';
import { TechnicianService } from '../../../../services/technician.service';
import { JobcardService } from '../../../../services/jobcard.service';
import { ServiceRequestService } from '../../../../services/servicerequest.service';
import { NotificationService } from '../../../../services/notification.service';
import { PaymentService } from '../../../../services/payment.service';
import { UserService } from '../../../../services/user.service';
import { ScheduleServiceComponent } from '../../../modals/schedule-service/schedule-service.component';
import { UpdateJobcardComponent } from '../../../modals/update-jobcard/update-jobcard.component';
import { WorkshopJobcardComponent } from '../../../modals/workshop-jobcard/workshop-jobcard.component';
import { AppConfig } from '../../../../app.config';
import { MessageService } from 'primeng/api';

import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

import { AddEditStaffLeaveComponent } from 'src/app/components/portal/bikeshop/users-v2/staff-leave/add-edit-staff-leave/add-edit-staff-leave.component';
import { AddEditCloseDateComponent } from 'src/app/components/modals/add-edit-close-date/add-edit-close-date.component';
import { UserEditComponent } from '../../../modals/user-edit/user-edit.component';
import { ConfirmationService } from 'primeng/api';
import { AvailabilityComponent } from './availability/availability.component';
import { JoyrideService } from 'ngx-joyride';
import { ActivatedRoute, Router } from '@angular/router';
import { NewJobcardService } from '../../../../services/new-jobcard.service';
import { WorkshopJobcardSearchSerialNumberComponent } from '../../../modals/workshop-jobcard/workshop-jobcard-search-serial-number/workshop-jobcard-search-serial-number.component';

import dazzle_icons from '../../../../components/shared/dazzle-icons/icons';
import { Subscription } from 'rxjs';
import { BroadcastService } from 'src/app/services/broadcast.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  providers: [MessageService],
})
export class CalendarComponent implements OnInit {
  @ViewChild('calendar') calendarComponent: FullCalendarComponent;
  @ViewChild(AvailabilityComponent)
  availabilityComponent: AvailabilityComponent;
  @ViewChild('searchtextbox') searchElement: ElementRef;

  public loading = false;
  public technicians: any = [];
  public techniciansHidden: any[] = [];
  public statusesHidden: any[] = [];
  public techniciansRaw: any = [];
  public techniciansOrig: any = [];
  public services: any = [];
  public partnerID: string = '';
  public profile: any = {};
  public partnerData: any = {};
  public connectedStores: any = [];
  public searchAllStores: boolean = false;
  public useNewScheduleScreen: boolean = false;
  public subscription: Subscription;

  showBorderinfo = false;
  showPaidinfo = false;
  showNotHereinfo = false;

  public countryData: any = {};
  public displayDateFormat: any = 'dd-MM-yyyy';
  public displayDateTimeFormat: any = 'dd-MM-yyyy HH:mm';
  showHoverTool = false;

  calendarVisible = true;
  calendarPlugins = [
    resourceDayGridPlugin,
    resourceTimeGridPlugin,
    resourceTimelinePlugin,
    dayGridPlugin,
    timeGridPlugin,
    interactionPlugin,
  ];
  headerView = 'resourceTimeGridDay, Week, TwoWeeks, dayGridMonth';
  calendarWeekends = true;
  workingHoursMinTime = '00:00:00';
  minTime = '00:00:00';
  maxTime = '24:00:00';
  calendarEvents: EventInput[] = [];
  event: any = [];
  public daysOfWeek = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];
  public calendarApi: Calendar;
  public jobCardData: any = {};
  public statusList: any = [];
  public jobApproved = {};

  public techniciansAllowed = 0;
  public showSearch: boolean = false;
  public searching: boolean = false;
  public searchRequest: any = "";
  public searchResults: any = [];
  public contentHeight: number = 800;
  public fullCalendarKey: '0984855613-fcs-1539348025';
  public header = {};
  public calendarButtonText = {
    today: 'today',
    month: 'month',
    week: 'week',
    day: 'day',
  };
  public nowTime: any = new Date();
  public addNew = false;
  public calendarViews: any = {
    resourceTimeGridDay: {
      titleFormat: {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        weekday: 'short',
      },
      slotDuration: '00:15:00',
      slotLabelInterval: '01:00:00',
      scrollTime: { Duration: '00:00:00' },
    },
    Week: {
      type: 'resourceTimelineWeek',
      titleFormat: {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        weekday: 'short',
      },
      eventTimeFormat: {
        hour: '2-digit',
        minute: '2-digit',
      },
      displayEventEnd: true,
      resourceAreaWidth: '150px',
      slotLabelFormat: [{ day: '2-digit', weekday: 'short' }],
      slotLabelInterval: { days: 1 },
      slotDuration: { days: 1 },
      scrollTime: { Duration: '01:00:00' },
    },
    TwoWeeks: {
      type: 'resourceTimelineWeek',
      titleFormat: {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        weekday: 'short',
      },
      resourceAreaWidth: '150px',
      slotLabelFormat: [{ day: '2-digit', weekday: 'short' }],
      slotLabelInterval: { days: 1 },
      slotDuration: { days: 1 },
      duration: { weeks: 2 },
      scrollTime: { Duration: '00:00:00' },
      buttonText: this.translate.instant('bikeshop.calendar.two_weeks'),
      firstDay: 1,
    },
  };

  statuses = {
    ToPickUp: 'To Pick Up',
    Scheduled: 'Scheduled',
    BookedIn: 'Booked In',
    FittingBooked: 'Fitting Booked',
    AssignedtoTechnician: 'Assigned to Technician',
    WaitingforWork: 'Waiting for Work',
    StartedWorking: 'Started Working',
    StartedWarrantyJob: 'Started Warranty Job',
    INeedHelp: 'I Need Help',
    WaitingForParts: 'Waiting For Parts',
    WaitingForClient: 'Waiting For Client',
    ServiceCompleted: 'Service Completed',
    ReadyforCollection: 'Ready for Collection',
    ToBeDelivered: 'To Be Delivered',
    Collected: 'Collected',
    FittingCompleted: 'Fitting Completed',
    AdhocEvent: 'Adhoc Event',
    leave: 'leave',
    Canceled: 'Canceled',
    WarrantyJob: 'Warranty Job',
  };

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.contentHeight =
      window.innerHeight - 195 < 470 ? 470 : window.innerHeight - 195;
  }

  @HostListener('touchend', ['$event'])
  onResizeExtra(event) {
    this.contentHeight =
      window.innerHeight - 195 < 470 ? 470 : window.innerHeight - 195;
  }

  public searchFor = '';
  public searchPage: number = 0;
  public hasMoreResults: boolean = true;
  public loadingMore: boolean = false;
  public showNoResults: boolean = false;

  constructor(
    public partnerService: PartnerService,
    public technicianService: TechnicianService,
    public helpersService: HelpersService,
    public jobcardService: JobcardService,
    public messageService: MessageService,
    public serviceRequest: ServiceRequestService,
    public modalService: NgbModal,
    public appConfig: AppConfig,
    private translate: TranslateService,
    private confirmationService: ConfirmationService,
    private joyrideService: JoyrideService,
    private checklistService: ChecklistService,
    public route: ActivatedRoute,
    public notificationService: NotificationService,
    private cyclistService: CyclistService,
    private paymentService: PaymentService,
    private userService: UserService,
    private newJobcardService: NewJobcardService,
    private broadcastService: BroadcastService,
    private router: Router
  ) {

  }



  getNowDate() {
    return moment(this.nowTime).format('YYYY-MM-DDTHH:mm:ss');
  }

  goToDate($event) {
    let date = new Date($event);
    this.calendarApi.gotoDate(date);
    this.calendarApi.changeView('resourceTimeGridDay');
  }

  addLeave() {
    // this.addNew = false;
    // const modalRef = this.modalService.open(AddEditLeaveComponent, {
    //   backdrop: "static",
    //   windowClass: "user-modal",
    // });
    // modalRef.componentInstance.users = this.technicians;
    // modalRef.result.then(
    //   (result) => {
    //     this.calendarApi.refetchEvents();
    //   }
    // );

    this.addNew = false;
    const modalRef = this.modalService.open(AddEditStaffLeaveComponent, {
      backdrop: 'static',
      windowClass: 'user-modal',
    });
    modalRef.componentInstance.technicians = this.technicians;
    modalRef.componentInstance.event = {};
    modalRef.result.then((result) => {
      this.calendarApi.refetchEvents();
    });
  }

  addClosedDate() {
    this.addNew = false;
    const modalRef = this.modalService.open(AddEditCloseDateComponent, {
      backdrop: 'static',
      windowClass: 'user-modal',
    });
    modalRef.componentInstance.users = this.technicians;
    modalRef.result.then((result) => {
      this.calendarApi.refetchEvents();
    });
  }

  ngOnInit() {
    this.partnerID = this.helpersService.getPartnerId();
    this.profile = this.helpersService.getProfileData();
    this.partnerData = this.helpersService.getPartnerData();

    this.countryData = this.helpersService.getCountryData();
    this.displayDateFormat = this.countryData.AngularDateFormat;
    this.displayDateTimeFormat =
      this.countryData.AngularDateFormat +
      ' ' +
      (this.countryData.code == 'US' ? 'hh:mm aa' : 'HH:mm');

    this.calendarViews.resourceTimeGridDay.slotDuration =
      this.partnerData.DefaultDayViewTimeInterval || '00:15:00';

    this.statusList = this.appConfig.getStatusList().filter(x => x.key !== 40).sort((a, b) => {
      if (a.order < b.order) return -1;
      else if (a.order > b.order) return 1;
      else return 0;
    });

    console.log(this.statusList);
    //this.getTechnicians();

    //This is jippo to remove the Week view for iPad with iOS9 i.e. Midstream Cycles. Had to make a work around to get the calendar to work but the week view falls over, so hiding it.
    if (
      window.navigator.userAgent.indexOf('iPad') > -1 &&
      window.navigator.userAgent.indexOf('Safari') > -1 &&
      window.navigator.userAgent.indexOf('Version/9') > -1
    ) {
      //this.headerView = 'resourceTimeGridDay, dayGridMonth';
    }

    this.calendarButtonText = {
      today: this.translate.instant('bikeshop.calendar.today'),
      month: this.translate.instant('bikeshop.calendar.month'),
      week: this.translate.instant('bikeshop.calendar.week'),
      day: this.translate.instant('bikeshop.calendar.day'),
    };

    if (this.helpersService.showTour('Calendar')) {
      const tag = document.createElement('script');
      //tag.src = "https://www.youtube.com/iframe_api";
      //document.body.appendChild(tag);

      //this.joyrideService.startTour({
      //  steps: ['calendarStepOne', 'calendarStepTwo', 'calendarStepThree'],
      //  themeColor: '#151A2A',
      //});
    }
    this.hasChecklistItems();

    this.route.queryParams.subscribe((params) => {
      if (params['ServiceID']) {
        if (params['view']) {
          this.openJobCard(params['ServiceID'], params['view']);
        } else {
          this.openJobCard(params['ServiceID']);
        }

        if (params['PartnerMessageID']) {
          this.notificationService
            .markMessageRead(this.profile.PartnerID, params['PartnerMessageID'])
            .subscribe((result) => { });
        }
      }
    });

    this.paymentService.getPaymentStatus(this.partnerID).subscribe((res) => {
      this.techniciansAllowed = res.techniciansAllowed;
    });

    this.getConnectedStores();
    this.createSubscription();


    if (this.router.url.toLowerCase().includes('/calendar/schedule-service')) {
      this.scheduleService();
    }
  }

  createSubscription() {
    this.subscription = this.broadcastService.getMessage().subscribe((data) => {
      let message = data.message;

      if (message === 'reload-calendar-events') {
        this.calendarApi.refetchEvents();
      }
    });
  }

  setTechnicianFiltering() {
    //console.log("Setting the filtering")
    //try {
    //  setInterval(() => {
    //    //console.log("Inside the settings");
    try {
      if (this.techniciansHidden) {
        //this.calendarApi.refetchResources();
        this.techniciansHidden.forEach((x) => {
          var resource = this.calendarApi.getResourceById(x);
          if (resource !== null) resource.remove();
        });
        //console.log(this.techniciansHidden);
      }
    } catch (e) {
      console.warn(e);
    }
    //  }, 150);
    //} catch (e) {
    //  console.error(e);
    //}
  }

  ngAfterViewInit() {
    this.calendarApi = this.calendarComponent.getApi();
    this.addCalendarEventSource();
    this.setCalendarRefresh();
    //this.setTechnicianFiltering();
    this.calendarApi.setOption('locale', this.appConfig.getLocale());
    this.calendarApi.setOption('eventAllow', (dropInfo: any) => {
      if (dropInfo.resource && dropInfo.resource.id === 'unassigned') {
        return false;
      }
      return true;
    });
    if (this.searchRequest.trim() !== "")
      this.highlight()
  }

  ngAfterContentInit() {
    this.contentHeight = window.innerHeight - 195;
  }

  toggleAdd() {
    this.addNew = !this.addNew;
  }

  hasChecklistItems() {
    this.checklistService.hasChecklistItems(this.partnerID).subscribe(
      (res) => {
        this.helpersService.setChecklistCount(res.checklistCount);
      },
      (err) => {
        this.helpersService.setChecklistCount(0);
      },
    );
  }

  //TODO I want to change this to use something like web sockets to notify the control that something changed.
  setCalendarRefresh() {
    setTimeout(() => {
      //dont reload when in month view as it may be too much data
      console.log(new Date());
      this.nowTime = new Date();
      if (
        this.calendarApi &&
        this.calendarApi.view &&
        this.calendarApi.view.type !== 'dayGridMonth'
      ) {
        this.calendarApi.refetchEvents();
        this.setCalendarRefresh();
      }
    }, 600000);
  }

  renderResource(info) {
    if (info.resource.id === 'unassigned') {
      return;
    }
    this.setTechnicianFiltering();
    var url =
      this.appConfig.getEnvironmentNew().url +
      '/Technician/iCalEvents/' +
      info.resource.extendedProps.technicianIdentifier +
      '?&TZ=' + (new Date().getTimezoneOffset() / 60) * -1 + '&code=' +
      this.appConfig.getEnvironmentNew().key;
    var messageService = this.messageService;
    var translate = this.translate;
    info.el.firstChild.innerHTML += `<div class="ical-link" id="${info.resource.extendedProps.technicianIdentifier}" title="${this.translate.instant('bikeshop.calendar.ical_info')}">
      <div><span class="fa fa-calendar-o"></span>${this.translate.instant('bikeshop.calendar.ical_link')}</div>
      <div style="display:none"><span class="fa fa-clone"></span>${this.translate.instant('bikeshop.calendar.copy_ical_link')}</div>
    </div>`;

    info.el.firstChild.innerHTML += `<div class="update-technician" id="${info.resource.extendedProps.technicianIdentifier}_configure">
      <div><span></span>${'Configure'}</div>
    </div>`;

    var div_ical = document.getElementById(
      info.resource.extendedProps.technicianIdentifier,
    );
    if (div_ical != null) {
      div_ical.onclick = function () {
        let anyNavigator: any;
        anyNavigator = window.navigator;
        anyNavigator.clipboard.writeText(url).then(() => {
          messageService.add({
            life: 5000,
            detail: translate.instant('bikeshop.calendar.ical_link_copied'),
            key: 'link-copied',
          });
        });
      };
    }

    var div_conf = document.getElementById(
      info.resource.extendedProps.technicianIdentifier + '_configure',
    );
    if (div_conf != null) {
      var _this = this;

      div_conf.onclick = function () {
        var technician = _this.technicians
          .filter((x) => {
            return x.id === parseInt(info.resource.id);
          })
          .pop();
        _this.cyclistService
          .getCyclistById(technician.userID)
          .subscribe((user) => {
            //For some bizzare reason, the API call above sometimes returns the technicianID as 0 or the wrong partner when the technician is a user in more than one store
            user.TechnicianID = technician.id;
            var allocatedTechnicians = _this.technicians.length;
            const modalRef = _this.modalService.open(UserEditComponent, {
              size: 'lg',
              backdrop: 'static',
              windowClass: 'user-modal',
            });
            modalRef.componentInstance.user = user;
            modalRef.componentInstance.techniciansAllowed =
              _this.techniciansAllowed;
            modalRef.componentInstance.allocatedTechnicians =
              allocatedTechnicians;
            modalRef.componentInstance.defaultTab = 'AVAILABILITY';
            modalRef.result.then(
              (result) => {
                _this.calendarApi.refetchEvents();
              },
              (onrejected) => {
                _this.calendarApi.refetchEvents();
              },
            );
          });
      };
    }
  }

  renderEvent(info) {
    let technicianName = info.el.children[1]?.innerText;

    if (info.el.children[1]) {
      if (info.el.children[1].innerText) {
        info.el.children[1].innerText = '';
      }

      if (info.el.children[1].innerHTML) {
        info.el.children[1].innerHTML = '';
      }
    }

    if (this.calendarApi && this.calendarApi.view.type !== 'dayGridMonth') {
      if (technicianName) {
        info.el.firstChild.innerHTML += `<div class='fc-other calendar-bike-name'>${technicianName}</div>`;
      }

      if (
        this.calendarApi.view.type == 'resourceTimeGridDay' &&
        info.event.extendedProps.jobCardNo
      ) {
        info.el.firstChild.innerHTML += `<div class='fc-other job-card-no-day'>#${info.event.extendedProps.jobCardNo}</div>`;
      }

      // info.el.firstChild.innerHTML += `<div class='fc-other calendar-card-duration'>30m</div>`;

      // if (info.event.extendedProps.originalBookInDate) {
      //   info.el.firstChild.innerHTML += `<div class='fc-other'><span class="fa fa-calendar-times-o" style="width: auto;margin-right: 2px;"></span>${moment(info.event.extendedProps.originalBookInDate).format('ha, Do MMM')}</div>`;
      // }
      if (info.event.extendedProps.bike) {
        info.el.firstChild.innerHTML += `<div class='fc-other calendar-bike'>${info.event.extendedProps.bike}</div>`;
        //   ${info.event.extendedProps.bikeBay ? '(' + info.event.extendedProps.bikeBay + ') => ' : ''}
      }
      // if (
      //   info.event.extendedProps.showBikeType &&
      //   info.event.extendedProps.bikeType
      // ) {
      //   info.el.firstChild.innerHTML += `<div class='fc-other calendar-bike-type'>${info.event.extendedProps.bikeType}</div>`;
      // }
      if (info.event.extendedProps.serviceType) {
        let servicesArr = info.event.extendedProps.serviceType
          .split(', ')
          .filter(function (item, pos, self) {
            return self.indexOf(item) === pos;
          });
        let cnt = 0;
        let end = false;
        for (let i = 0; i <= servicesArr.length - 1; i++) {
          if (i < 2) {
            info.el.firstChild.innerHTML += `<div class='fc-other'>${servicesArr[i].trim()}</div>`;
          } else if (i == 2 && servicesArr.length > 3) {
            info.el.firstChild.innerHTML += `<div class='fc-other'>${servicesArr[i].trim()} + ${servicesArr.length - 3}</div>`;
          } else if (i == 2 && servicesArr.length == 3) {
            info.el.firstChild.innerHTML += `<div class='fc-other'>${servicesArr[i].trim()}</div>`;
          }
        }
        // info.event.extendedProps.serviceType
        //   .split(', ')
        //   .filter(function (item, pos, self) {
        //     return self.indexOf(item) === pos;
        //   })
        //   .forEach((service) => {
        //     info.el.firstChild.innerHTML += `<div class='fc-other'>${service.trim()}</div>`;
        //   });
      }

      // let status = this.calculateStatusText(info.event.classNames[0]);
      if (info.event.extendedProps.statusText) {
        info.el.firstChild.innerHTML += `<div class='fc-other job-status-chip'>${info.event.extendedProps.statusText}</div>`;
      }

      // if (info.event.classNames[0] == 'INeedHelp') {
      //   info.el.firstChild.innerHTML += `<div class='fc-other job-status-chip'>${info.event.extendedProps.iNeedHelpLabel}</div>`;
      // }

      if (
        info.event.extendedProps.jobCardNo &&
        this.calendarApi.view.type != 'resourceTimeGridDay'
      ) {
        info.el.firstChild.innerHTML += `<div class='fc-other job-card-no'>#${info.event.extendedProps.jobCardNo}</div>`;
      }

      var icons = `<div class="fc-icons">`;

      if (info.event.extendedProps.collection) {
        icons += `<span class="job-card-icon"><svg viewBox="0 0 20 20" style="margin-left: -3px;" class="svg-icon" height="16" width="30" fill="none">${this.createIcon('truck')}</svg></span>`;
      }

      if (info.event.classNames[0].includes('ToBeDelivered')) {
        icons += `<span class="job-card-icon"><svg viewBox="0 0 20 20" style="margin-left: -3px;" class="svg-icon" height="16" width="30" fill="none">${this.createIcon('truck')}</svg></span>`;
      }

      if (info.event.extendedProps.showBikeIsNotHere) {
        // icons += `<span class="fa hubtiger-bike-not-here" style="width:20px"></span>`;
        info.el.className += ' bike-not-here';
      }

      // if (info.event.extendedProps.iNeedHelp) {
      //   // icons += `<span class="fa fa-flag-o"></span>`;
      //   icons += `<span class="job-card-icon"><svg viewBox="0 0 20 20" class="svg-icon" height="16" width="30" fill="none">${this.createIcon('flag')}</svg></span>`;
      // }

      if (info.event.extendedProps.linked) {
        info.el.className += ' linked-job';
      }
      //
      // if (info.event.extendedProps.paidWithStripe) {
      //   info.el.className += ' job-is-paid';
      //   // icons += `<span class="fa hubtiger-stripe" style="margin-top:4px;margin-right:2px;"></span>`;
      // } else if (info.event.extendedProps.complete) {
      //   // icons += `<span class="pi hubtiger-bike-ready"></span>`;
      // }
      //
      // if (info.event.extendedProps.paidWithPOS) {
      //   // icons += `<span class="fa fa-money" style="margin-top:4px;margin-right:2px;"></span>`;
      //   info.el.className += ' job-is-paid';
      // } else if (info.event.extendedProps.sentToPOS) {
      //   // icons += `<span class="fa hubtiger-sent-to-pos"></span>`;
      // }

      if (info.event.extendedProps.thirdPartyID > 0) {
        icons += `<span class="job-card-icon"><svg viewBox="0 0 20 20" class="svg-icon" height="16" fill="none">${this.createIcon('people')}</svg>
</span>`;
      }

      // if ((info.event.extendedProps.collectionState || info.event.extendedProps.notReceived) && info.event.extendedProps.bookedWith === "App") {
      //   icons += `<span class="fa fa-mobile" style="font-size: 20px;"></span>`;
      // } else if ((info.event.extendedProps.collectionState || info.event.extendedProps.notReceived) && info.event.extendedProps.bookedWith === "Widget") {
      //   icons += `<span class="fa fa-desktop"></span>`;
      // } else if ((info.event.extendedProps.collectionState || info.event.extendedProps.notReceived) && info.event.extendedProps.bookedWith === "Portal") {
      //   icons += `<span class="fa "></span>`;
      // }

      if (info.event.extendedProps.bookedWith === 'App') {
        icons += `<span class="job-card-icon"><svg viewBox="0 0 20 20" class="svg-icon" style="margin-left: 4px" height="16" fill="none">${this.createIcon('mobile')}</svg></span>`;
      } else if (info.event.extendedProps.bookedWith === 'Widget') {
        icons += `<span class="job-card-icon"><svg viewBox="0 0 24 24" class="svg-icon" style="margin-top: 4px" height="16" fill="none">${this.createIcon('laptop')}</svg></span>`;
      } else if (info.event.extendedProps.bookedWith === 'Portal') {
        // No icon for portal
        //  icons += `<span class="job-card-icon"><svg viewBox="0 0 20 20" style="margin-top: 2px" class="svg-icon" height="16" fill="none">${this.createIcon('widget')}</svg></span>`;
      }

      if (info.event.extendedProps.ApprovedStatus) {
        if (info.event.extendedProps.ApprovedStatus === 2) {
          icons += `<span  class="job-card-icon"><svg viewBox="0 0 20 20" style="margin-left: -2px;" class="svg-icon" height="16" fill="none">${this.createIcon('check')}</svg></span>`;
          // icons += `<span class="fa hubtiger-approved"></span>`;
        } else {
          // icons += `<span class="fa hubtiger-not-approved"></span>`;
          icons += `<span  class="job-card-icon"><svg viewBox="0 0 20 20" style="margin-right: -3px;" class="svg-icon" height="15" fill="none">${this.createIcon('file-block')}</svg></span>`;
        }
      }

      if (info.event.extendedProps.sentToPOS) {
        icons += `<span  class="job-card-icon"><span class="fa hubtiger-sent-to-pos"></span></span>`;
        // icons += `<span class="fa hubtiger-sent-to-pos"></span>`;
      }

      /*if (info.event.extendedProps.waiting) {
                                                        icons += `<span class="pi pi-clock"></span>`;
                                                }*/

      icons += `</div>`;
      info.el.firstChild.innerHTML += icons;
      if (
        info.event.extendedProps.bikeBay &&
        this.calendarApi.view.type != 'resourceTimeGridDay'
      ) {
        info.el.firstChild.innerHTML += `<div class="fc-bay-info"><span class='fc-other bike-bay-no'>${info.event.extendedProps.bikeBay}</span></div>`; //todo translate
      }

      //if (info.event.extendedProps.statusText) {
      //  info.el.firstChild.innerHTML += `<div class='fc-other job-status-chip'>${info.event.extendedProps.statusText}</div>`;
      //}

      if (info.event.extendedProps.tags) {
        if (info.event.extendedProps.tags.length > 0) {
          var txt = `<div style="display:flex; flex-wrap: wrap; max-width: 165px;">`
          info.event.extendedProps.tags.forEach((tag) => {
            txt += `<div style="margin-right: 6px;" class='fc-other job-status-chip'>${tag.tag}</div>`;
          });
          txt += `</div>`
          info.el.firstChild.innerHTML += txt;
        }
      }
    }

    if (info.event.extendedProps.showBikeIsNotHere) {
      // icons += `<span class="fa hubtiger-bike-not-here" style="width:20px"></span>`;
      info.el.className += ' bike-not-here';
    }

    // if (info.event.extendedProps.iNeedHelp) {
    //   // icons += `<span class="fa fa-flag-o"></span>`;
    //   icons += `<span class="job-card-icon"><svg viewBox="0 0 20 20" class="svg-icon" height="16" width="30" fill="none">${this.createIcon('flag')}</svg></span>`;
    // }

    if (info.event.extendedProps.linked) {
      info.el.className += ' linked-job';
    }

    if (info.event.extendedProps.paidWithStripe) {
      info.el.className += ' job-is-paid';
      if (this.calendarApi.view.type == 'resourceTimeGridDay') {
        info.el.className += ' job-is-paid-day';
      }
      // icons += `<span class="fa hubtiger-stripe" style="margin-top:4px;margin-right:2px;"></span>`;
    } else if (info.event.extendedProps.complete) {
      // icons += `<span class="pi hubtiger-bike-ready"></span>`;
    }

    if (info.event.extendedProps.paidWithPOS) {
      if (this.calendarApi.view.type == 'resourceTimeGridDay') {
        info.el.className += ' job-is-paid-day';
      }
      // icons += `<span class="fa fa-money" style="margin-top:4px;margin-right:2px;"></span>`;
      info.el.className += ' job-is-paid';
    }
  }

  canShowHover = false;

  eventMouseEnter(event) {
    this.canShowHover = true;
    setTimeout(() => {
      if (this.calendarApi.view.type == 'resourceTimeGridDay') {
        // Get the event card's position
        const rect = event.el.getBoundingClientRect();

        // Get the popup element
        const popup = document.getElementById('iso-popup');

        // Position the popup based on the event card's position
        if (popup && this.canShowHover) {
          popup.style.display = 'block';
          popup.style.left = `${rect.left + window.scrollX - 175}px`;
          popup.style.top = `${rect.bottom + window.scrollY - 250}px`; // Adjust top position based on the bottom of the event card
          popup.innerHTML = this.createPopup(event); // Add dynamic content, e.g., title and start date
        }
      }
    }, 1000); // 2000 milliseconds = 2 seconds
  }

  createPopup(event) {
    let popupData = ``;

    popupData += `<div class='popup-header'>`;
    if (event.event.extendedProps.jobCardNo) {
      popupData += `<span class='fc-other job-card-no'>#${event.event.extendedProps.jobCardNo} </span>`;
    }

    if (event.event.title) {
      popupData += `<span class='fc-other calendar-bike-name-hover'>${event.event.title}</span>`;
    }

    if (event.event.extendedProps.statusText) {
      popupData += `<span class='fc-other job-status-chip-hover ${event.event.extendedProps.statusClass}'>${event.event.extendedProps.statusText} </span>`;
    }

    popupData += `</div>`;

    if (event.event.extendedProps.bike) {
      popupData += `<div class='fc-other calendar-bike-hover'>${event.event.extendedProps.bike}</div>`;
    }

    popupData += '<div class="first-service"></div>';

    if (event.event.extendedProps.serviceType) {
      let servicesArr = event.event.extendedProps.serviceType
        .split(', ')
        .filter(function (item, pos, self) {
          return self.indexOf(item) === pos;
        });
      let cnt = 0;
      let end = false;
      for (let i = 0; i <= servicesArr.length - 1; i++) {
        if (i < 2) {
          popupData += `<div class='fc-other service-hover'>${servicesArr[i].trim()}</div>`;
        } else if (i == 2 && servicesArr.length > 3) {
          popupData += `<div class='fc-other service-hover'>${servicesArr[i].trim()} + ${servicesArr.length - 3}</div>`;
        } else if (i == 2 && servicesArr.length == 3) {
          popupData += `<div class='fc-other service-hover'>${servicesArr[i].trim()}</div>`;
        }
      }
      // info.event.extendedProps.serviceType
      //   .split(', ')
      //   .filter(function (item, pos, self) {
      //     return self.indexOf(item) === pos;
      //   })
      //   .forEach((service) => {
      //     info.el.firstChild.innerHTML += `<div class='fc-other'>${service.trim()}</div>`;
      //   });
    }

    popupData += '<div class="hover-footer"></div>';

    return popupData;
  }

  eventMouseLeave(event) {
    this.canShowHover = false;
    if (this.calendarApi.view.type == 'resourceTimeGridDay') {
      // Hide the popup
      const popup = document.getElementById('iso-popup');
      if (popup) {
        popup.style.display = 'none';
      }
    }
  }

  createIcon(icon) {
    return dazzle_icons[icon]
      .replace('%color%', '#060931')
      .replace('stroke-width="2"', 'stroke-width="1.25"');
  }

  isSlotAvailable(eventID, resourceID, dateStr, eventDuration) {
    var technicianEvents = this.calendarApi
      .getResourceById(resourceID)
      .getEvents()
      .filter((resourceEvent) => {
        return moment.utc(resourceEvent.start).format('YYYY-MM-DD') === dateStr;
      });
    var technician = this.technicians.filter((technician) => {
      return technician.id.toString() === resourceID.toString();
    });

    let totalTimeOfEvent = this.getTotalTimeOfEvents(technicianEvents);
    var businessHours =
      technician && technician.length > 0
        ? technician[0].businessHours.filter((day) => {
          return day.daysOfWeek[0] === moment.utc(dateStr).day();
        })[0]
        : { endTime: '19:00' };
    if (!businessHours) {
      businessHours = { startTime: '00:00', endTime: '00:00' };
    }
    let totalBusinessHoursTime = this.getTotalBusinessHoursTime(businessHours);

    if (totalBusinessHoursTime <= totalTimeOfEvent) {
      return false;
    }

    return true;
  }

  getTotalTimeOfEvents(technicianEvents) {
    let totalMilliseconds = 0;
    for (let techEvent of technicianEvents) {
      const startTime = new Date(techEvent.start).getTime();
      const endTime = new Date(techEvent.end).getTime();
      const duration = endTime - startTime; // Duration in milliseconds

      if (duration > 0) {
        totalMilliseconds += duration;
      }
    }
    return totalMilliseconds;
  }

  getTotalBusinessHoursTime(businessHours) {
    const [startHours, startMinutes] = businessHours.startTime
      .split(':')
      .map(Number);
    const [endHours, endMinutes] = businessHours.endTime.split(':').map(Number);

    const today = new Date();
    const startDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      startHours,
      startMinutes,
      0,
    );
    const endDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      endHours,
      endMinutes,
      0,
    );

    // Calculate the difference in milliseconds
    let millisecondsDifference = endDate.getTime() - startDate.getTime();
    return millisecondsDifference;
  }

  getNextAvailableTimeSlot(
    eventID,
    resourceID,
    dateStr,
    eventDuration,
    ignoreLeave = true,
  ) {
    var technicianEvents = this.calendarApi
      .getResourceById(resourceID)
      .getEvents()
      .filter((resourceEvent) => {
        return moment.utc(resourceEvent.start).format('YYYY-MM-DD') === dateStr;
      });
    var technician = this.technicians.filter((technician) => {
      return technician.id.toString() === resourceID.toString();
    });
    var businessHours =
      technician && technician.length > 0
        ? technician[0].businessHours.filter((day) => {
          return day.daysOfWeek[0] === moment.utc(dateStr).day();
        })[0]
        : { startTime: '09:00', endTime: '17:00' };
    var startOfDay =
      dateStr + 'T' + (businessHours ? businessHours.startTime : '00:00') + 'Z';
    var endOfDay =
      dateStr + 'T' + (businessHours ? businessHours.endTime : '00:00') + 'Z';
    var lastServiceTime =
      dateStr + 'T' + (businessHours ? businessHours.startTime : '00:00') + 'Z';

    if (
      technicianEvents.filter((e) => {
        return (
          e.id !== eventID && ((ignoreLeave && e.id !== '') || !ignoreLeave)
        );
      }).length > 0
    ) {
      var exit = false;
      technicianEvents
        .filter((e) => {
          return (
            e.id !== eventID && ((ignoreLeave && e.id !== '') || !ignoreLeave)
          );
        })
        .sort((a, b) => {
          if (a.start < b.start) {
            return -1;
          } else if (a.start > b.start) {
            return 1;
          } else {
            return 0;
          }
        })
        .forEach((e, index, array) => {
          if (!exit) {
            if (
              index === 0 &&
              moment.utc(e.start).diff(moment.utc(startOfDay), 'minute') > 0 &&
              moment.utc(startOfDay).hour() !== 0
            ) {
              lastServiceTime = startOfDay;
              exit = true;
            } else if (
              index > 0 &&
              moment
                .utc(e.start)
                .diff(
                  moment.utc(
                    array[index - 1].end == null
                      ? moment.utc(array[index - 1].start).add(1, 'hour')
                      : array[index - 1].end,
                  ),
                  'minute',
                ) >= eventDuration
            ) {
              lastServiceTime =
                moment
                  .utc(
                    array[index - 1].end == null
                      ? moment.utc(array[index - 1].start).add(1, 'hour')
                      : array[index - 1].end,
                  )
                  .format('YYYY-MM-DD') +
                'T' +
                moment
                  .utc(
                    array[index - 1].end == null
                      ? moment.utc(array[index - 1].start).add(1, 'hour')
                      : array[index - 1].end,
                  )
                  .format('HH:mm') +
                'Z';
              exit = true;
            }
          }
        });

      if (!exit) {
        var eventLastDate = new Date(
          Math.max.apply(
            null,
            technicianEvents
              .filter((e: any) => {
                return (
                  e.id !== eventID &&
                  ((ignoreLeave && e.id !== '') || !ignoreLeave)
                );
              })
              .map((e: any) => {
                return e.end == null
                  ? moment.utc(e.start).add(1, 'hour')
                  : e.end;
              }),
          ),
        ).toUTCString();
        lastServiceTime =
          moment.utc(eventLastDate).format('YYYY-MM-DD') +
          'T' +
          moment.utc(eventLastDate).format('HH:mm') +
          'Z';
      }
    }

    if (
      moment(lastServiceTime).utc().hour() === 0 &&
      moment(endOfDay).utc().hour() === 0
    ) {
      var updatedDate = moment(lastServiceTime).utc();
      updatedDate.set('hour', 9);
      lastServiceTime =
        moment(updatedDate).utc().format('YYYY-MM-DD') +
        'T' +
        moment(updatedDate).utc().format('HH:mm') +
        'Z';
    }

    return lastServiceTime;
  }

  dateClicked(event: any) {
    if (event.view.type === 'dayGridMonth') {
      //Will see what we can do to book in from the month view, problem is we do not have a technician id or a time for the event.
    } else if (event.view.type === 'Week') {
      if (
        !this.isSlotAvailable(event.id, event.resource.id, event.dateStr, 60)
      ) {
        this.confirmationService.confirm({
          key: 'confirm_move',
          rejectVisible: true,
          acceptLabel: this.translate.instant('general.yes'),
          rejectLabel: this.translate.instant('general.no'),
          header: this.translate.instant(
            'bikeshop.calendar.move_jobcard_header',
          ),
          message: this.translate.instant('bikeshop.calendar.create_jobcard'),
          accept: () => {
            this.scheduleBooking(event);
          },
          reject: () => { },
        });
      } else {
        this.scheduleBooking(event);
      }
    } else if (
      event.view.type === 'TwoWeeks' ||
      event.view.type === 'resourceTimeGridDay'
    ) {
      this.technicianService
        .getTechnicianOpenSlots(
          this.partnerID,
          event.resource.id,
          event.dateStr,
          '',
        )
        .subscribe((res) => {
          if (res && res.openSlots && res.openSlots.length > 0) {
            this.scheduleBooking(event, res.openSlots[0]);
          } else {
            this.confirmationService.confirm({
              key: 'confirm_move',
              rejectVisible: true,
              acceptLabel: this.translate.instant('general.yes'),
              rejectLabel: this.translate.instant('general.no'),
              header: this.translate.instant(
                'bikeshop.calendar.move_jobcard_header',
              ),
              message: this.translate.instant(
                'bikeshop.calendar.create_jobcard',
              ),
              accept: () => {
                this.scheduleBooking(event);
              },
              reject: () => { },
            });
          }
        });
    } else {
      this.scheduleBooking(event);
    }
  }

  scheduleBooking(event: any, slot: any = null) {
    if (this.useNewScheduleScreen || this.partnerData.UseNewJobCard) {
      this.newJobcardService.scheduleWorkshopService({
        partnerId: this.partnerID,
        partnerData: this.partnerData,
        event: event,
        slot: slot,
        getNextAvailableTimeSlot: this.getNextAvailableTimeSlot.bind(this),
        isSlotAvailable: this.isSlotAvailable.bind(this),
        openJobCard: this.openJobCard.bind(this),
        onRefreshEvents: () => this.calendarApi.refetchEvents()
      });
      return;
    }

    const modalRef = this.modalService.open(ScheduleServiceComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.partnerId = this.partnerID;
    if (event.view.type === 'Week') {
      try {
        var lastServiceTime = this.getNextAvailableTimeSlot(
          event.id,
          event.resource.id,
          event.dateStr,
          180,
          this.isSlotAvailable(event.id, event.resource.id, event.dateStr, 60)
            ? false
            : true,
        );
        modalRef.componentInstance.selectedTimeSlot = lastServiceTime;
      } catch (err) {
        modalRef.componentInstance.selectedTimeSlot = event.dateStr;
      }
    } else if (event.view.type === 'TwoWeeks' && slot && slot.availableSlot) {
      modalRef.componentInstance.selectedTimeSlot = slot.availableSlot;
    } else {
      modalRef.componentInstance.selectedTimeSlot = event.dateStr;
    }
    modalRef.componentInstance.technician = {
      id: event.resource.id,
      name: event.resource.name,
    };
    modalRef.componentInstance.fromCalendar = true;
    modalRef.result.then(
      (result) => {
        this.messageService.add({ life: 5000, detail: result.message });
        if (event.view.type === 'Week' && !result.bookingDateChanged) {
          var timeSlot = this.getNextAvailableTimeSlot(
            result.jobcard.ID.toString(),
            result.jobcard.TechnicianID.toString(),
            moment(result.jobcard.DateCheckedIn).format('YYYY-MM-DD'),
            result.jobcard.Duration,
            this.isSlotAvailable(event.id, event.resource.id, event.dateStr, 60)
              ? false
              : true,
          );
          var data = {
            DateCheckedIn: timeSlot,
            ID: result.jobcard.ID,
            TechnicianID: result.jobcard.TechnicianID,
          };
          this.serviceRequest.updateJobCardSlot(data).subscribe((res) => {
            this.calendarApi.refetchEvents();
          });
        } else {
          this.calendarApi.refetchEvents();
        }

        if (result.openBooking && result.jobcard && result.jobcard.ID) {
          this.openJobCard(
            result.jobcard.ID,
            this.partnerData.OpenTabOnScheduleAndOpen,
          );
        }

        setTimeout(() => {
          if (
            this.partnerData &&
            this.partnerData.OpenPrintOnNewJob &&
            result.jobcard.StatusID > 15 &&
            result.jobcard.StatusID < 50
          ) {
            if (this.helpersService.getPrinterType() === 'A4') {
              var win = window.open(`/print/${result.jobcard.ID}`, '_blank');
              win.focus();
            } else {
              var win = window.open(
                `/print-till-slip/${result.jobcard.ID}`,
                '_blank',
              );
              win.focus();
            }
          }
        }, 1000);
      },
      (onrejected) => { },
    );
  }

  scheduleClicked(event: any) {
    if (event.event.classNames.indexOf('AdhocEvent') > -1) {
      this.openLeave(event.event.extendedProps.leave);
    } else {
      const summaryData = {
        JobCardNo: event.event.extendedProps.jobCardNo,
        Name: event.event.title,
      };
      this.openJobCard(event.event.id, 'JOBCARD', summaryData);
    }
  }

  // openJobCard(jobcardID, defaultTab = "JOBCARD") {
  //   //this.calendarApi.gotoDate(jobcard.DateCheckedIn);
  //   this.serviceRequest.getServiceRequestData(jobcardID).subscribe((jobcard) => {
  //       const modalRef = this.modalService.open(UpdateJobcardComponent, {
  //         size: "lg",
  //         //backdrop: "static",
  //         windowClass: "jobcard-modal",
  //         backdrop: true
  //       });
  //       modalRef.componentInstance.jobApproved = this.jobApproved[jobcard.ID];
  //       modalRef.componentInstance.jobcard = jobcard;
  //       modalRef.componentInstance.partnerID = this.partnerID;
  //       modalRef.componentInstance.defaultTab = defaultTab;
  //       modalRef.result.then(
  //         (result) => { },
  //         (onrejected) => {
  //           this.calendarApi.refetchEvents();
  //         }
  //       );
  //     });
  // }

  openJobCard(jobcardID, defaultTab = 'JOBCARD', summaryData = null) {
    //this.calendarApi.gotoDate(jobcard.DateCheckedIn);
    if (this.useNewScheduleScreen || this.partnerData.UseNewJobCard) {
      this.newJobcardService.openManageJobCard(jobcardID, {
        onRefreshEvents: () => this.calendarApi.refetchEvents()
      }, defaultTab ? defaultTab.toLocaleLowerCase() === 'notifications' : false);
      return;
    }

    const modalRef = this.modalService.open(UpdateJobcardComponent, {
      size: 'lg',
      //backdrop: "static",
      windowClass: 'jobcard-modal',
      backdrop: true,
    });
    modalRef.componentInstance.jobApproved = this.jobApproved[jobcardID];
    modalRef.componentInstance.jobcard = null;
    modalRef.componentInstance.summaryData = summaryData;
    modalRef.componentInstance.jobcardID = jobcardID;
    modalRef.componentInstance.partnerID = this.partnerID;
    modalRef.componentInstance.defaultTab = defaultTab;
    modalRef.result.then(
      (result) => { },
      (onrejected) => {
        this.calendarApi.refetchEvents();
      },
    );
  }

  openLeave(leave) {
    const modalRef = this.modalService.open(AddEditStaffLeaveComponent, {
      backdrop: 'static',
      windowClass: 'user-modal',
    });
    modalRef.componentInstance.technicians = this.technicians;
    modalRef.componentInstance.event = {
      ...leave,
      ID: leave.id,
      Description: leave.description,
      StartTime: leave.startTime,
      EndTime: leave.endTime,
      TechnicianID: leave.technicianID,
      RecurrenceID: leave.recurrenceID,
    };

    modalRef.result.then(
      (result) => {
        this.calendarApi.refetchEvents();
      },
      (onrejected) => {
        this.calendarApi.refetchEvents();
      },
    );
  }

  scheduleMovedOld(event: any) {
    //console.log(event)
    this.serviceRequest
      .getServiceRequestData(event.event.id)
      .subscribe(async (jobcard) => {
        let new_start = new Date(event.event.start);
        let new_end = new Date(event.event.end);
        if (
          event.newResource !== null ||
          moment(event.event.start).format('YYYY-MM-DDTHH:ss') !=
          moment(event.oldEvent.start).format('YYYY-MM-DDTHH:ss')
        ) {
          jobcard.DateCheckedIn = new_start.toISOString(); //Store the Date as UTC
          var prevTechnicianId = jobcard.TechnicianID;
          if (event.newResource) {
            jobcard.TechnicianID = event.newResource.id;
            jobcard.TechnicianDescription = event.newResource.title;
          }

          if (
            event.view.type === 'Week' ||
            event.view.type === 'dayGridMonth'
          ) {
            if (
              !this.isSlotAvailable(
                event.event.id,
                jobcard.TechnicianID,
                moment(new_start).format('YYYY-MM-DD'),
                moment(new_end).diff(new_start, 'minute'),
              )
            ) {
              this.confirmationService.confirm({
                key: 'confirm_move',
                rejectVisible: true,
                acceptLabel: this.translate.instant('general.yes'),
                rejectLabel: this.translate.instant('general.no'),
                header: this.translate.instant(
                  'bikeshop.calendar.move_jobcard_header',
                ),
                message: this.translate.instant(
                  'bikeshop.calendar.move_jobcard',
                ),
                accept: () => {
                  var nextAvailableTimeslot = this.getNextAvailableTimeSlot(
                    event.event.id,
                    jobcard.TechnicianID,
                    moment(new_start).format('YYYY-MM-DD'),
                    moment(new_end).diff(new_start, 'minute'),
                    this.isSlotAvailable(
                      event.event.id,
                      jobcard.TechnicianID,
                      moment(new_start).format('YYYY-MM-DD'),
                      moment(new_end).diff(new_start, 'minute'),
                    )
                      ? false
                      : true,
                  );
                  jobcard.DateCheckedIn = nextAvailableTimeslot;
                  this.updateEvent(jobcard, event, prevTechnicianId);
                },
                reject: () => {
                  this.calendarApi.refetchEvents();
                },
              });
            } else {
              var nextAvailableTimeslot = this.getNextAvailableTimeSlot(
                event.event.id,
                jobcard.TechnicianID,
                moment(new_start).format('YYYY-MM-DD'),
                moment(new_end).diff(new_start, 'minute'),
                this.isSlotAvailable(
                  event.event.id,
                  jobcard.TechnicianID,
                  moment(new_start).format('YYYY-MM-DD'),
                  moment(new_end).diff(new_start, 'minute'),
                )
                  ? false
                  : true,
              );
              jobcard.DateCheckedIn = nextAvailableTimeslot;
              this.updateEvent(jobcard, event, prevTechnicianId);
            }
          } else {
            this.updateEvent(jobcard, event, prevTechnicianId);
          }
        }
      });
  }

  updateEvent(jobcard, event, prevTechnicianId) {

    console.log('Updating event', jobcard, this.partnerData);


    this.serviceRequest
      .saveServiceRequest(jobcard)
      .subscribe((savedJobCard) => {
        this.messageService.add({
          life: 5000,
          summary: this.translate.instant('bikeshop.calendar.job_update'),
          detail: this.translate.instant(
            'bikeshop.calendar.message_job_updated',
            { JobCardNo: jobcard.JobCardNo },
          ),
        });
        //TODO... check what to call if a job is unallocated and then needs to be allocated... why does this call not do that since we passing a new technicain ID???
        if (prevTechnicianId === 0) {
          this.serviceRequest
            .assignToTechnician(event.event.id, jobcard.TechnicianID)
            .subscribe((result) => {
              this.calendarApi.refetchEvents();
            });
        } else {
          this.calendarApi.refetchEvents();
        }
      });
  }

  scheduleMoved(event: any) {
    //console.log(event)
    // Block drops onto the unassigned resource

    if (this.partnerData.LockJobCardOnCollection && event.event.extendedProps.statusClass == 'Collected') {
      event.revert();
      return;
    }

    if (event.newResource && event.newResource.id === 'unassigned') {
      event.revert();
      return;
    }
    // Block time-only moves for events sitting on the unassigned resource
    if (event.newResource === null) {
      const currentResources = event.event.getResources ? event.event.getResources() : [];
      if (currentResources.length > 0 && currentResources[0].id === 'unassigned') {
        event.revert();
        return;
      }
    }
    if (event.event.extendedProps && event.event.extendedProps.jobCardNo) {
      var technicianID =
        event.newResource === null
          ? event.event.extendedProps.technicianID
          : event.newResource.id;
      let new_start = moment.utc(event.event.start).toISOString();
      let new_end = moment.utc(event.event.end).toISOString();

      if (
        event.newResource !== null ||
        moment.utc(event.event.start).format('YYYY-MM-DDTHH:mm') !=
        moment.utc(event.oldEvent.start).format('YYYY-MM-DDTHH:mm')
      ) {
        if (
          event.view.type === 'Week' ||
          event.view.type === 'dayGridMonth' ||
          event.view.type === 'TwoWeeks'
        ) {
          if (
            !this.isSlotAvailable(
              event.event.id,
              technicianID,
              moment.utc(new_start).format('YYYY-MM-DD'),
              moment.utc(new_end).diff(new_start, 'minute'),
            )
          ) {
            this.confirmationService.confirm({
              key: 'confirm_move',
              rejectVisible: true,
              acceptLabel: this.translate.instant('general.yes'),
              rejectLabel: this.translate.instant('general.no'),
              header: this.translate.instant(
                'bikeshop.calendar.move_jobcard_header',
              ),
              message: this.translate.instant('bikeshop.calendar.move_jobcard'),
              accept: () => {
                var nextAvailableTimeslot = this.getNextAvailableTimeSlot(
                  event.event.id,
                  technicianID,
                  moment.utc(new_start).format('YYYY-MM-DD'),
                  moment.utc(new_end).diff(new_start, 'minute'),
                  this.isSlotAvailable(
                    event.event.id,
                    technicianID,
                    moment.utc(new_start).format('YYYY-MM-DD'),
                    moment.utc(new_end).diff(new_start, 'minute'),
                  )
                    ? false
                    : true,
                );
                this.updateEventV2(
                  event.event.id,
                  technicianID,
                  nextAvailableTimeslot,
                  event,
                );
              },
              reject: () => {
                event.revert();
              },
            });
          } else {
            var nextAvailableTimeslot = this.getNextAvailableTimeSlot(
              event.event.id,
              technicianID,
              moment.utc(new_start).format('YYYY-MM-DD'),
              moment.utc(new_end).diff(new_start, 'minute'),
              this.isSlotAvailable(
                event.event.id,
                technicianID,
                moment.utc(new_start).format('YYYY-MM-DD'),
                moment.utc(new_end).diff(new_start, 'minute'),
              )
                ? false
                : true,
            );
            this.updateEventV2(
              event.event.id,
              technicianID,
              nextAvailableTimeslot,
              event,
            );
          }
        } else {
          this.updateEventV2(
            event.event.id,
            technicianID,
            moment.utc(new_start).toISOString(),
            event,
          );
        }
      }
    } else {
      event.revert();
    }
  }

  updateEventV2(serviceID, technicianID, dateCheckedIn, event) {
    var data = {
      ID: serviceID,
      TechnicianID: technicianID,
      DateCheckedIn: dateCheckedIn,
    };

    var updatedEvent = this.calendarApi.getEventById(event.event.id);
    let endDate = new Date(dateCheckedIn);
    endDate.setMinutes(
      endDate.getMinutes() + event.event.extendedProps.duration,
    );
    var end = moment(endDate).utc().toISOString();
    updatedEvent.setDates(dateCheckedIn, end);

    this.serviceRequest.updateJobCardSlot(data).subscribe(
      (res) => {
        if (this.availabilityComponent) {
          this.availabilityComponent.getData();
        }
      },
      (err) => {
        event.revert();
      },
    );
  }

  scheduleDurationChanged(event: any) {
    this.serviceRequest
      .getServiceRequestData(event.event.id)
      .subscribe((jobcard) => {
        jobcard.Duration =
          jobcard.Duration + event.endDelta.milliseconds / 1000 / 60;
        this.serviceRequest
          .saveServiceRequest(jobcard)
          .subscribe((savedJobCard) => {
            this.messageService.add({
              life: 5000,
              summary: this.translate.instant('bikeshop.calendar.job_update'),
              detail: this.translate.instant(
                'bikeshop.calendar.message_job_updated',
                { JobCardNo: jobcard.JobCardNo },
              ),
            });
          });
      });
  }

  //closeSearch() {
  //  this.showSearch = false;
  //  this.searchRequest = '';
  //  this.searchResults = [];
  //}

  handleSearchClick() {
    this.showNoResults = false;
    this.showSearch = !this.showSearch;


    setTimeout(() => {
      // this will make the execution after the above boolean has changed
      this.searchElement.nativeElement.focus();
    }, 50);
  }

  search_old() {
    if (this.searchRequest.length > 0) {
      this.searching = true;
      let searchRequest: any = {
        PartnerID: this.partnerID,
        Search: this.searchRequest,
        SearchAllStores: this.searchAllStores,
        SearchType: this.searchFor
      };

      try {
        this.serviceRequest.jobCardServiceRequest(searchRequest).subscribe(
          (searchResults) => {
            this.searching = false;
            this.searchResults = searchResults.map((result) => {
              var status = this.appConfig
                .getStatusList()
                .filter((x) => {
                  return x.id === result.StatusID;
                })
                .pop();
              result.className = status ? status.styleClass : '';
              result.StatusDescription = status
                ? status.label
                : result.StatusID === 100
                  ? this.translate.instant('bikeshop.statuses.cancelled')
                  : '';

              return result;


            });
          },
          (err) => {
            this.searching = false;
            this.searchResults = [];
          },
        );
      } catch (err) {
        this.searching = false;
      }
    }
  }


  //search() {
  //  if (this.searchRequest.length > 0) {
  //    this.searching = true;
  //    //let searchRequest: any = {
  //    //  PartnerID: this.partnerID, 
  //    //  Search: this.searchRequest,
  //    //  SearchAllStores: this.searchAllStores,
  //    //  SearchType: this.searchFor
  //    //};

  //    try {
  //      this.serviceRequest.getCalendarSearch(this.partnerID, this.searchFor, this.searchRequest, 0).subscribe(
  //        (searchResults) => {
  //          this.searching = false;
  //          this.searchResults = searchResults.map((result) => {
  //            var status = this.appConfig
  //              .getStatusList()
  //              .filter((x) => {
  //                return x.id === result.StatusID;
  //              })
  //              .pop();
  //            result.className = status ? status.styleClass : '';
  //            result.StatusDescription = status
  //              ? status.label
  //              : result.StatusID === 100
  //                ? this.translate.instant('bikeshop.statuses.cancelled')
  //                : '';

  //            return result;


  //          });
  //        },
  //        (err) => {
  //          this.searching = false;
  //          this.searchResults = [];
  //        },
  //      );
  //    } catch (err) {
  //      this.searching = false;
  //    }
  //  }
  //}

  generateJobCard(event) {
    this.partnerService.getNextJobcardID(this.partnerID).subscribe((result) => {
      this.loading = false;
      event.display = true;
      this.jobCardData = event;
    });
  }

  getMinTime(result) {
    var min = 24;

    result.forEach((day) => {
      var tmpMin = day.startTime ? parseInt(day.startTime.substring(0, 2)) : 0;
      if (tmpMin > 0 && tmpMin < min) {
        min = tmpMin;
      }
    });

    if (
      this.minTime === '00:00:00' ||
      min - 1 < parseInt(this.minTime.substring(0, this.minTime.indexOf(':')))
    ) {
      this.minTime = min - 2 + ':00:00';
    }
  }

  getMaxTime(result) {
    var max = 0;

    result.forEach((day) => {
      var tmpMax = day.endTime ? parseInt(day.endTime.substring(0, 2)) : 24;
      if (tmpMax < 24 && tmpMax > max) {
        max = tmpMax;
      }
    });
    if (
      (this.maxTime === '24:00:00' && max != 0) ||
      max + 2 > parseInt(this.maxTime.substring(0, this.maxTime.indexOf(':')))
    ) {
      this.maxTime = max + 2 + ':00:00';
    }
  }

  getEventDates() {
    var dates = [];
    for (
      var i = moment.utc(this.calendarApi.view.currentStart);
      i < moment.utc(this.calendarApi.view.currentEnd);
      i.add(1, 'days')
    ) {
      dates.push(i.format('YYYY-MM-DD'));
    }
    return dates;
  }

  tourDone() {
    this.helpersService.tourComplete('Calendar');
  }

  addCalendarEventSource() {
    this.calendarApi.addEventSource((event, callback) => {
      this.event = event;
      this.getCalendarEvents(
        event.start.toISOString(),
        event.end.toISOString(),
      );
      callback([]);
    });
  }

  getCalendarEvents(fromDate, toDate) {
    this.loading = true;
    this.partnerService
      .getPartnerOpenJobCardsV2(this.partnerID, fromDate, toDate)
      .subscribe(
        (result) => {
          this.techniciansOrig = result.technicians;
          this.setTechnicianData(result.technicians);
          if (this.statusesHidden.length > 0) {
            var filtered = [];
            result.services.forEach((x) => {
              if (!this.statusesHidden.includes(x.statusID))
                if (filtered.findIndex((z) => z.serviceID == x.serviceID) == -1)
                  filtered.push(x);
            });
            result.services = filtered;
            //this.calendarApi.refetchEvents();
          }
          if (this.techniciansHidden.length > 0) {
            this.techniciansHidden.forEach((x) => {
              var resource = this.calendarApi.getResourceById(x);
              if (resource !== null) resource.remove();
            });
          }

          var isTechnicianOnly = false;
          var roles = this.profile.UserRoles.filter((x) => { return x.PartnerID === this.helpersService.getPartnerId(); }).map((x) => { return x.RoleID; });
          if (
            !roles.includes(2) &&
            !roles.includes(3) &&
            !roles.includes(9) &&
            (roles.includes(1) || roles.includes(4)) &&
            this.profile.TechnicianID &&
            !this.profile.IsSuperUser
          ) {
            isTechnicianOnly = true;
          }

          const activeTechnicianIds = new Set(this.technicians.map((t: any) => t.id));
          const hasOrphanedJobs = result.services.some((s: any) => s.technicianID && !activeTechnicianIds.has(s.technicianID));
          if (hasOrphanedJobs && !isTechnicianOnly) {
            this.technicians.push({
              id: 'unassigned',
              userID: null,
              title: this.translate.instant('bikeshop.calendar.unassigned') || 'Unassigned',
              businessHours: [{ startTime: '00:00', endTime: '00:00', daysOfWeek: [100] }],
              Name: 'Unassigned',
              extendedProps: { technicianIdentifier: 'unassigned' },
              sortOrder: 9999,
              workHours: {},
              actualWorkingHours: [],
            });
          }

          this.services = result.services;
          this.setJobData(result.services);
          this.setLeaveEvents(result.events);
          this.loading = false;
        },
        (err) => {
          this.loading = true;
        },
      );
  }

  setJobData(bookings) {
    this.calendarApi.removeAllEvents();
    const knownTechnicianIds = new Set(
      this.technicians.filter((t: any) => t.id !== 'unassigned').map((t: any) => t.id)
    );
    if (bookings) {
      bookings.forEach((booking) => {
        var checkInDate = booking.dateCheckedIn + 'Z'; //This is a bit of a jippo to force the calendar to use this date as UTC
        if (
          moment(booking.dateCheckedIn).format('YYYY-MM-DD') ===
          moment(this.event.start).format('YYYY-MM-DD') &&
          moment(booking.dateCheckedIn).hours() <
          parseInt(this.minTime.substring(0, this.minTime.indexOf(':')))
        ) {
          this.minTime = moment(booking.dateCheckedIn).format('HH') + ':00:00';
        }
        let startDate = new Date(checkInDate);
        let endDate = new Date(checkInDate);
        endDate.setMinutes(endDate.getMinutes() + booking.duration);
        this.jobApproved[booking.serviceID] = booking.approvedStatus;

        var status = this.appConfig
          .getStatusList()
          .filter((x) => {
            return x.key === booking.statusID;
          })
          .pop();
        var styleClass = '';
        if (status) {
          styleClass = status.styleClass;
        } else if (booking.statusID === 10) {
          styleClass = 'BookedIn';
        } else if (booking.statusID === 41) {
          styleClass = 'Collected';
        } else if (booking.statusID >= 40 && booking.statusID <= 45) {
          styleClass = 'ReadyforCollection';
        }

        this.calendarApi.addEvent({
          ApprovedStatus: booking.approvedStatus,
          id: booking.serviceID,
          resourceId: knownTechnicianIds.has(booking.technicianID) ? booking.technicianID : 'unassigned',
          technicianID: booking.technicianID,
          durationEditable: knownTechnicianIds.has(booking.technicianID) ? (booking.statusID <= 40) : false,
          selectable: true,
          //editable: booking.StatusID <= 40,
          iNeedHelp: booking.statusID == 31,
          bikeBay: booking.bikeBay,
          linked: booking.linked,
          showBikeIsNotHere: !booking.bikeIsHere && booking.statusID < 50,
          start: startDate,
          end: endDate,
          duration: booking.duration,
          originalBookInDate:
            this.partnerData.ShowOriginalDateOnCalendar &&
              booking.originalBookInDate !== booking.dateCheckedIn
              ? booking.originalBookInDate
              : null,
          title: '' + booking.customer,
          className: styleClass,
          jobCardNo: booking.jobCardNo,
          bike: booking.bike,
          serviceType: booking.types
            ? booking.types
              .map((x) => {
                return x.typeDescription;
              })
              .join(', ')
            : '',
          bookedWith: booking.bookedWith,
          collectionState: booking.statusID === 5,
          collection: booking.collection,
          sentToPOS: booking.sentToPOS,
          showBikeType: this.partnerData.ShowBikeTypeOnCalendar,
          bikeTypeID: booking.bikeTypeID,
          bikeType: booking.bikeType
            ? this.translate.instant(booking.bikeType)
            : null,
          waiting:
            booking.statusID === 30 || booking.statusID === 35 ? true : false,
          complete:
            booking.statusID >= 40 && booking.statusID <= 45 ? true : false,
          paidWithPOS: booking.paidWithPOS ? true : false,
          paidWithStripe: booking.paidWithStripe ? true : false,
          busy: booking.statusID === 25 ? true : false,
          notReceived: booking.statusID == 15 ? true : false,
          thirdPartyID: booking.thirdPartyID,
          thirdPartyIsResponsibleForPayment:
            booking.thirdPartyIsResponsibleForPayment,
          statusText: status ? status.label : '',
          statusClass: styleClass,
          tags: booking.tags,
        });
      });
    }
  }

  setLeaveEvents(leaveEvents) {
    if (leaveEvents) {
      leaveEvents.forEach((event) => {
        this.calendarApi.addEvent({
          resourceId: event.technicianID,
          id: event.id,
          start: event.startTime,
          end: event.endTime,
          title: event.description,
          className: 'AdhocEvent',
          editable: false,
          selectable: true,
          durationEditable: false,
          leave: event,
        });
      });
    }
  }

  setTechnicianData(technichainData) {
    //console.log(technichainData);
    this.minTime = '00:00:00';
    this.maxTime = '24:00:00';
    this.technicians = [];
    this.techniciansRaw = [];
    var technicians = technichainData.map((technician) => {
      return {
        id: technician.id,
        userID: technician.userID,
        title: technician.technicianName,
        businessHours: [],
        Name: technician.technicianName,
        extendedProps: {
          technicianIdentifier: technician.technicianIdentifier,
        },
        sortOrder: technician.sortOrder,
        workHours: technician.workHours,
        actualWorkingHours: technician.actualWorkingHours,
      };
    });
    setTimeout(() => {
      this.techniciansRaw = JSON.parse(JSON.stringify(technicians));
    }, 50);
    //If logged in user is a technician, only show my record... (Should actually filter on the backend based on the users role)
    var roles = this.profile.UserRoles.filter((x) => {
      return x.PartnerID === this.helpersService.getPartnerId();
    }).map((x) => {
      return x.RoleID;
    });
    if (
      !roles.includes(2) &&
      !roles.includes(3) &&
      !roles.includes(9) &&
      (roles.includes(1) || roles.includes(4)) &&
      this.profile.TechnicianID &&
      !this.profile.IsSuperUser
    ) {
      technicians = technicians.filter(
        (technician) => this.profile.TechnicianID === technician.id,
      );
    }
    this.getTechniciansWorkHours(technicians);
  }

  getTechniciansWorkHours(technicians) {
    technicians.forEach((technician) => {
      if (technician.id > 0) {
        this.workingHoursMinTime = this.minTime;

        technician.businessHours = [];

        if (
          this.calendarApi.view.type === 'Week' &&
          ((technician.workHours.MondayStart !== null &&
            technician.workHours.MondayStart !== '00:00') ||
            (technician.workHours.MondayEnd !== null &&
              technician.workHours.MondayEnd !== '00:00'))
        ) {
          technician.businessHours.push({
            startTime:
              technician.workHours.MondayStart === null
                ? '00:00'
                : technician.workHours.MondayStart,
            endTime:
              technician.workHours.MondayEnd === null
                ? '00:00'
                : technician.workHours.MondayEnd,
            daysOfWeek: [1],
          });
        } else if (this.calendarApi.view.type !== 'Week') {
          technician.businessHours.push({
            startTime:
              technician.workHours.MondayStart === null
                ? '00:00'
                : technician.workHours.MondayStart,
            endTime:
              technician.workHours.MondayEnd === null
                ? '00:00'
                : technician.workHours.MondayEnd,
            daysOfWeek: [1],
          });
        }

        if (
          this.calendarApi.view.type === 'Week' &&
          ((technician.workHours.TuesdayStart !== null &&
            technician.workHours.TuesdayStart !== '00:00') ||
            (technician.workHours.TuesdayEnd !== null &&
              technician.workHours.TuesdayEnd !== '00:00'))
        ) {
          technician.businessHours.push({
            startTime:
              technician.workHours.TuesdayStart === null
                ? '00:00'
                : technician.workHours.TuesdayStart,
            endTime:
              technician.workHours.TuesdayEnd === null
                ? '00:00'
                : technician.workHours.TuesdayEnd,
            daysOfWeek: [2],
          });
        } else if (this.calendarApi.view.type !== 'Week') {
          technician.businessHours.push({
            startTime:
              technician.workHours.TuesdayStart === null
                ? '00:00'
                : technician.workHours.TuesdayStart,
            endTime:
              technician.workHours.TuesdayEnd === null
                ? '00:00'
                : technician.workHours.TuesdayEnd,
            daysOfWeek: [2],
          });
        }

        if (
          this.calendarApi.view.type === 'Week' &&
          ((technician.workHours.WednesdayStart !== null &&
            technician.workHours.WednesdayStart !== '00:00') ||
            (technician.workHours.WednesdayEnd !== null &&
              technician.workHours.WednesdayEnd !== '00:00'))
        ) {
          technician.businessHours.push({
            startTime:
              technician.workHours.WednesdayStart === null
                ? '00:00'
                : technician.workHours.WednesdayStart,
            endTime:
              technician.workHours.WednesdayEnd === null
                ? '00:00'
                : technician.workHours.WednesdayEnd,
            daysOfWeek: [3],
          });
        } else if (this.calendarApi.view.type !== 'Week') {
          technician.businessHours.push({
            startTime:
              technician.workHours.WednesdayStart === null
                ? '00:00'
                : technician.workHours.WednesdayStart,
            endTime:
              technician.workHours.WednesdayEnd === null
                ? '00:00'
                : technician.workHours.WednesdayEnd,
            daysOfWeek: [3],
          });
        }

        if (
          this.calendarApi.view.type === 'Week' &&
          ((technician.workHours.ThursdayStart !== null &&
            technician.workHours.ThursdayStart !== '00:00') ||
            (technician.workHours.ThursdayEnd !== null &&
              technician.workHours.ThursdayEnd !== '00:00'))
        ) {
          technician.businessHours.push({
            startTime:
              technician.workHours.ThursdayStart === null
                ? '00:00'
                : technician.workHours.ThursdayStart,
            endTime:
              technician.workHours.ThursdayEnd === null
                ? '00:00'
                : technician.workHours.ThursdayEnd,
            daysOfWeek: [4],
          });
        } else if (this.calendarApi.view.type !== 'Week') {
          technician.businessHours.push({
            startTime:
              technician.workHours.ThursdayStart === null
                ? '00:00'
                : technician.workHours.ThursdayStart,
            endTime:
              technician.workHours.ThursdayEnd === null
                ? '00:00'
                : technician.workHours.ThursdayEnd,
            daysOfWeek: [4],
          });
        }

        if (
          this.calendarApi.view.type === 'Week' &&
          ((technician.workHours.FridayStart !== null &&
            technician.workHours.FridayStart !== '00:00') ||
            (technician.workHours.FridayEnd !== null &&
              technician.workHours.FridayEnd !== '00:00'))
        ) {
          technician.businessHours.push({
            startTime:
              technician.workHours.FridayStart === null
                ? '00:00'
                : technician.workHours.FridayStart,
            endTime:
              technician.workHours.FridayEnd === null
                ? '00:00'
                : technician.workHours.FridayEnd,
            daysOfWeek: [5],
          });
        } else if (this.calendarApi.view.type !== 'Week') {
          technician.businessHours.push({
            startTime:
              technician.workHours.FridayStart === null
                ? '00:00'
                : technician.workHours.FridayStart,
            endTime:
              technician.workHours.FridayEnd === null
                ? '00:00'
                : technician.workHours.FridayEnd,
            daysOfWeek: [5],
          });
        }

        if (
          this.calendarApi.view.type === 'Week' &&
          ((technician.workHours.SaturdayStart !== null &&
            technician.workHours.SaturdayStart !== '00:00') ||
            (technician.workHours.SaturdayEnd !== null &&
              technician.workHours.SaturdayEnd !== '00:00'))
        ) {
          technician.businessHours.push({
            startTime:
              technician.workHours.SaturdayStart === null
                ? '00:00'
                : technician.workHours.SaturdayStart,
            endTime:
              technician.workHours.SaturdayEnd === null
                ? '00:00'
                : technician.workHours.SaturdayEnd,
            daysOfWeek: [6],
          });
        } else if (this.calendarApi.view.type !== 'Week') {
          technician.businessHours.push({
            startTime:
              technician.workHours.SaturdayStart === null
                ? '00:00'
                : technician.workHours.SaturdayStart,
            endTime:
              technician.workHours.SaturdayEnd === null
                ? '00:00'
                : technician.workHours.SaturdayEnd,
            daysOfWeek: [6],
          });
        }

        if (
          this.calendarApi.view.type === 'Week' &&
          ((technician.workHours.SundayStart !== null &&
            technician.workHours.SundayStart !== '00:00') ||
            (technician.workHours.SundayEnd !== null &&
              technician.workHours.SundayEnd !== '00:00'))
        ) {
          technician.businessHours.push({
            startTime:
              technician.workHours.SundayStart === null
                ? '00:00'
                : technician.workHours.SundayStart,
            endTime:
              technician.workHours.SundayEnd === null
                ? '00:00'
                : technician.workHours.SundayEnd,
            daysOfWeek: [0],
          });
        } else if (this.calendarApi.view.type !== 'Week') {
          technician.businessHours.push({
            startTime:
              technician.workHours.SundayStart === null
                ? '00:00'
                : technician.workHours.SundayStart,
            endTime:
              technician.workHours.SundayEnd === null
                ? '00:00'
                : technician.workHours.SundayEnd,
            daysOfWeek: [0],
          });
        }

        //This calendar control is silly, if you dont add at least one bussinessHour day, it does not grey out any of the days, so now we adding one fake one
        technician.businessHours.push({
          startTime: '00:00',
          endTime: '00:00',
          daysOfWeek: [100],
        });

        //We only want to block out the week view here, day view is fine as it shows the greyed out non-working hours, two week view cant show non-working days due to calendar limits
        if (
          this.calendarApi.view.type === 'Week' ||
          this.calendarApi.view.type === 'resourceTimeGridDay'
        ) {
          this.setTechnicianOffDays(technician);
        }
        if (this.calendarApi.view.type === 'resourceTimeGridDay') {
          this.getMinTime(technician.businessHours);
          this.getMaxTime(technician.businessHours);
          this.setMinTimeTechServices(technician.id);
        }
        this.technicians.push(technician);
        //this.calendarApi.refetchResources();
      }
    });

    console.log('MinTime: ' + this.minTime + ' MaxTime: ' + this.maxTime);
  }

  setMinTimeTechServices(technicianID) {
    this.services
      .filter((x) => {
        return (
          x.technicianID === technicianID &&
          moment(x.dateCheckedIn).format('YYYY-MM-DD') ===
          moment(this.calendarApi.view.currentStart).format('YYYY-MM-DD')
        );
      })
      .forEach((service) => {
        var checkInDate = service.dateCheckedIn;
        var startHour = parseInt(moment(checkInDate).format('HH'));
        var minHour = parseInt(
          moment(
            '1970-01-01T' +
            (this.minTime.length === 8 ? this.minTime : '0' + this.minTime),
          ).format('HH'),
        );
        if (startHour < minHour) {
          this.minTime = startHour + ':00:00';
        }
      });
  }

  setTechnicianOffDays(technician) {
    if (
      technician.actualWorkingHours &&
      technician.actualWorkingHours.length > 0
    ) {
      technician.actualWorkingHours.forEach((customHours) => {
        if (
          moment(customHours.date).toDate() >=
          moment(
            moment
              .utc(this.calendarApi.view.currentStart)
              .format('YYYY-MM-DD'),
          ).toDate() &&
          moment(customHours.date).toDate() <=
          moment(
            moment.utc(this.calendarApi.view.currentEnd).format('YYYY-MM-DD'),
          ).toDate()
        ) {
          //Remove any days from the business hours where a custom day is set to not working i.e. override default
          if (
            !customHours.isWorking ||
            (customHours.startTime === '00:00:00' &&
              customHours.endTime === '00:00:00')
          ) {
            var index = technician.businessHours
              .map((x) => {
                return x.daysOfWeek[0];
              })
              .indexOf(moment(customHours.date).weekday());
            if (index > -1) {
              technician.businessHours.splice(index, 1);
            }
          }
          //Add any days to the bussiness days where the default is not working but the override is working
          if (
            customHours.isWorking &&
            customHours.startTime !== '00:00:00' &&
            customHours.endTime !== '00:00:00'
          ) {
            var index = technician.businessHours
              .map((x) => {
                return x.daysOfWeek[0];
              })
              .indexOf(moment(customHours.date).weekday());
            if (index === -1) {
              technician.businessHours.push({
                startTime: customHours.startTime,
                endTime: customHours.endTime,
                daysOfWeek: [moment(customHours.date).weekday()],
              });
            } else if (index > -1) {
              technician.businessHours.splice(index, 1);
              technician.businessHours.push({
                startTime: customHours.startTime,
                endTime: customHours.endTime,
                daysOfWeek: [moment(customHours.date).weekday()],
              });
            }
          }
        }
      });
    }
  }

  datesRender(event) {
    if (!this.loading) {
      this.setTechnicianData(this.techniciansOrig);
      this.setTechnicianFiltering();
    }
  }

  filterTechnicians(id: string) {
    //this.techniciansBackup = this.technicians;
    //this.technicians = this.technicians.filter(x => { return x.id === parseInt(id) }).pop();
    //this.calendarApi.refetchEvents();

    if (this.techniciansHidden.length == 0)
      this.calendarApi.getResources().forEach((x) => {
        this.techniciansHidden.push(parseInt(x._resource.id));
      });

    if (this.techniciansHidden.indexOf(id) > -1)
      this.techniciansHidden.splice(this.techniciansHidden.indexOf(id), 1);
    else this.techniciansHidden.push(id);

    this.calendarApi.refetchResources();
    this.techniciansHidden.forEach((x) => {
      if (x != id) {
        var resource = this.calendarApi.getResourceById(x);
        if (resource !== null) resource.remove();
      }
    });

    this.calendarApi.refetchEvents();

    //if (this.techniciansHidden.indexOf(id) == -1) {
    //  this.techniciansHidden.push(id)
    //  var resource = this.calendarApi.getResourceById(id);
    //  if (resource !== null)
    //    resource.remove();
    //}
    //else {
    //  if (this.techniciansHidden.length > 0) {
    //    var temp: any[] = [];
    //    this.techniciansHidden.forEach(x => {
    //      if (x !== id)
    //        temp.push(x);
    //    });
    //    this.techniciansHidden = temp;
    //    this.calendarApi.refetchResources();
    //    this.techniciansHidden.forEach(x => {
    //      var resource = this.calendarApi.getResourceById(x);
    //      if (resource !== null)
    //        resource.remove();
    //    })
    //    this.calendarApi.refetchEvents();
    //  }
    //}
  }

  resetFilteredTechnicians() {
    this.techniciansHidden = [];
    this.calendarApi.refetchResources();
    this.calendarApi.refetchEvents();
  }

  resetFilteredStatuses() {
    this.statusesHidden = [];
    this.getCalendarEvents(
      this.event.start.toISOString(),
      this.event.end.toISOString(),
    );
  }

  filterStatuses(id) {
    if (this.statusesHidden.length == 0) {
      this.appConfig.getStatusList().forEach((x) => {
        this.statusesHidden.push(x.key);
      });
      this.statusesHidden.push(41);
      this.statusesHidden.push(16);
    }

    if (this.statusesHidden.indexOf(id) > -1) {
      this.statusesHidden.splice(this.statusesHidden.indexOf(id), 1);
      if (id == 45)
        this.statusesHidden.splice(this.statusesHidden.indexOf(41), 1);
      if (id == 20)
        this.statusesHidden.splice(this.statusesHidden.indexOf(16), 1);
    } else {
      this.statusesHidden.push(id);
      if (id == 45) this.statusesHidden.push(41);
      if (id == 20) this.statusesHidden.push(16);
    }
    this.getCalendarEvents(
      this.event.start.toISOString(),
      this.event.end.toISOString(),
    );
    //if (this.statusesHidden.indexOf(id) == -1) {
    //  this.statusesHidden.push(id)
    //  this.getCalendarEvents(this.event.start.toISOString(), this.event.end.toISOString());
    //}
    //else {
    //  var temp: any[] = [];
    //  this.statusesHidden.forEach(x => {
    //    if (x !== id)
    //      temp.push(x);
    //  });
    //  this.statusesHidden = temp;
    //  this.getCalendarEvents(this.event.start.toISOString(), this.event.end.toISOString());
    //}
  }

  calculateStatusText(status) {
    for (let key of Object.keys(this.statuses)) {
      if (key === status) {
        return this.statuses[key];
      }
    }
    return '';
  }

  translateStatus(status) {
    for (let key of Object.keys(this.statuses)) {
      if (key === status) {
        return this.statuses[key];
      }
    }
    return '';
  }

  getConnectedStores() {
    this.userService.getConnectedBikeShops().subscribe((partners) => {
      this.connectedStores = partners;
    });
  }

  //updateSearch() {
  //  if (this.searchResults && this.searchResults.length > 0) {
  //    this.search();
  //  }
  //}

  scheduleService() {

    if (this.useNewScheduleScreen || this.partnerData.UseNewJobCard) {
      this.newJobcardService.scheduleWorkshopService({
        partnerId: this.partnerID,
        partnerData: this.partnerData,
        openJobCard: this.openJobCard.bind(this),
        onRefreshEvents: () => this.calendarApi.refetchEvents()
      });
      return;
    }

    const modalRef = this.modalService.open(ScheduleServiceComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.partnerId = this.partnerID;

    modalRef.componentInstance.fromCalendar = false;
    modalRef.result.then(
      (result) => {
        this.messageService.add({ life: 5000, detail: result.message });
        this.calendarApi.refetchEvents();

        if (result.openBooking && result.jobcard && result.jobcard.ID) {
          this.openJobCard(
            result.jobcard.ID,
            this.partnerData.OpenTabOnScheduleAndOpen,
          );
        }

        setTimeout(() => {
          if (
            this.partnerData &&
            this.partnerData.OpenPrintOnNewJob &&
            result.jobcard.StatusID > 15 &&
            result.jobcard.StatusID < 50
          ) {
            if (this.helpersService.getPrinterType() === 'A4') {
              var win = window.open(`/print/${result.jobcard.ID}`, '_blank');
              win.focus();
            } else {
              var win = window.open(
                `/print-till-slip/${result.jobcard.ID}`,
                '_blank',
              );
              win.focus();
            }
          }
        }, 1000);
      },
      (onrejected) => {
        this.calendarApi.refetchEvents();
      },);
  }

  scheduleServiceUsingBarcode() {

    if (this.useNewScheduleScreen || this.partnerData.UseNewJobCard) {
      const modalRef = this.modalService.open(WorkshopJobcardSearchSerialNumberComponent, {
        backdrop: true,
        backdropClass: 'jobcard-modal-popup-backdrop',
        windowClass: 'jobcard-modal-popup-window',
        size: 'lg'
      });

      modalRef.result.then(
        (result) => {
          console.log('Serial number search result:', result);
          // TODO: pass the looked-up item + customer through once the serial search returns them
          console.log(result);
          this.newJobcardService.scheduleWorkshopService({
            partnerId: this.partnerID,
            partnerData: this.partnerData,
            selectedItem: result.selectedItem,
            customer: result.customer,
            openJobCard: this.openJobCard.bind(this),
            onRefreshEvents: () => this.calendarApi.refetchEvents()
          });
        },
        (onrejected) => { },
      );
    }
  }


  highlight() {
    setTimeout(() => {

      //console.log('Search results:', this.searchResults);
      //if (this.searchResults.length === 0) {
      //  this.showNoResults = true;
      //}


      console.log("highlighting", this.searchRequest.trim());
      this.removeHighlight();
      if (this.searchResults.length === 0) { return; }
      var text = this.searchRequest.trim();

      // Escape special regex characters
      var escapedText = text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

      // Create case-insensitive regex
      var regex = new RegExp(escapedText, 'gi');

      Array.prototype.slice.call(document.querySelectorAll("#results-container *:not(script):not(style):not(noscript)"))
        .map(function (elem) {
          return Array.prototype.slice.call(elem.childNodes);
        })
        .reduce(function (nodesA, nodesB) {
          return nodesA.concat(nodesB);
        })
        .filter(function (node) {
          return node.nodeType === document.TEXT_NODE &&
            node.textContent.toLowerCase().indexOf(text.toLowerCase()) > -1;
        })
        .forEach(function (node) {
          var nextNode = node.nextSibling,
            parent = node.parentNode,
            content = node.textContent,
            newNodes = [];

          node.parentNode.removeChild(node);

          // Split using case-insensitive regex
          var parts = content.split(regex);
          var matches = content.match(regex) || [];

          parts.forEach(function (part, i) {
            newNodes.push(document.createTextNode(part));

            if (i < parts.length - 1 && matches[i]) {
              var mark = document.createElement("mark");
              mark.textContent = matches[i]; // Use the actual matched text (preserves case)
              mark.setAttribute("style", "padding: 0px; background-color: lightgray;")
              newNodes.push(mark);
            }
          });

          newNodes.forEach(function (n) {
            if (nextNode) {
              parent.insertBefore(n, nextNode);
            } else {
              parent.appendChild(n);
            }
          });
        });
    }, 250);
  }

  removeHighlight() {
    Array.prototype.slice.call(document.querySelectorAll("#results-container mark"))
      .forEach(function (mark) {
        var parent = mark.parentNode;
        var textContent = mark.textContent;

        // Replace the mark element with a text node
        var textNode = document.createTextNode(textContent);
        parent.replaceChild(textNode, mark);

        // Normalize to merge adjacent text nodes
        parent.normalize();
      });
  }

  changeSearch() {
    const trimmedSearch = this.searchRequest.trim();
    this.removeHighlight();
    this.showNoResults = false;
    this.searchResults = [];
    if (trimmedSearch.length === 0) {
      this.searchResults = [];
      return;
    }

    if (!trimmedSearch) {
      this.searchFor = '';
      return;
    }

    // Contains @ → Email
    if (trimmedSearch.indexOf('@') > -1) {
      this.searchFor = 'email';
      return;
    }

    // Starts with + → Phone
    if (trimmedSearch.indexOf('+') == 0) {
      this.searchFor = 'phone';
      return;
    }

    // Starts with # → jobcardNo
    if (trimmedSearch.indexOf('#') == 0) {
      this.searchFor = 'jobcardNo';
      return;
    }

    // Check if it's purely numeric
    const isNumeric = /^\d+$/.test(trimmedSearch);

    if (isNumeric) {
      const digitCount = trimmedSearch.length;

      // Numbers fewer than 7 digits → Job Card number
      if (digitCount < 7) {
        this.searchFor = 'jobcardNo';
        return;
      }

      // Numbers 7 or more digits → Phone number
      if (digitCount >= 7) {
        this.searchFor = 'phone';
        return;
      }
    }

    // Check if it contains any digits (alphanumeric)
    const hasDigits = /\d/.test(trimmedSearch);

    // Alphanumeric → Serial No.
    if (hasDigits && trimmedSearch.length <= 6) {
      this.searchFor = 'bay';
      return;
    }

    // Alphanumeric → Serial No.
    if (hasDigits) {
      this.searchFor = 'serialNo';
      return;
    }

    // Text with no digits and no @ → Name
    this.searchFor = 'name';
  }


  onResultsScroll(event: any) {
    const element = event.target;
    const scrollPercentage = (element.scrollTop / (element.scrollHeight - element.clientHeight)) * 100;

    // When scroll reaches 75% of container height
    if (scrollPercentage >= 75 && !this.loadingMore && this.hasMoreResults && !this.searching && this.searchRequest.trim() !== '') {
      this.loadMoreResults();
    }
  }

  loadMoreResults() {
    if (this.searchRequest.length === 0 || this.loadingMore || !this.hasMoreResults) {
      return;
    }

    this.loadingMore = true;
    this.searchPage++;

    try {
      this.serviceRequest.getCalendarSearch(this.partnerID, this.searchFor, this.searchRequest, this.searchPage, this.searchAllStores).subscribe(
        async (newResults) => {
          if (newResults && newResults.length > 0) {
            // Map the new results with status classes
            const mappedResults = newResults.map((result) => {
              var status = this.appConfig
                .getStatusList()
                .filter((x) => {
                  return x.id === result.StatusID;
                })
                .pop();
              result.className = status ? status.styleClass : '';
              result.StatusDescription = status
                ? status.label
                : result.StatusID === 100
                  ? this.translate.instant('bikeshop.statuses.cancelled')
                  : '';
              return result;
            });

            // Append new results to existing ones
            this.searchResults = [...this.searchResults, ...mappedResults];

            // If we got fewer results than expected (less than 20), we've likely reached the end
            if (newResults.length < 20) {
              this.hasMoreResults = false;
            }
          } else {
            this.hasMoreResults = false;
          }
          this.loadingMore = false;

          // Highlight search term in newly loaded results
          await new Promise(resolve => setTimeout(resolve, 50));
          this.highlight();
        },
        (err) => {
          this.loadingMore = false;
          console.error('Error loading more results:', err);
        }
      );
    } catch (err) {
      this.loadingMore = false;
    }
  }

  search() {
    if (this.searchRequest.length > 0) {
      // Reset pagination when starting a new search
      this.searchPage = 0;
      this.hasMoreResults = true;
      this.searching = true;
      this.searchResults = [];
      var searchForDisplay = this.searchRequest;
      if (searchForDisplay.trim().indexOf('#') == 0) {
        searchForDisplay = searchForDisplay.replaceAll("#", "");
      }

      try {
        this.serviceRequest.getCalendarSearch(this.partnerID, this.searchFor, searchForDisplay, 0, this.searchAllStores).subscribe(
          async (searchResults) => {
            this.searching = false;
            if (!searchResults || searchResults.length === 0) {
              this.showNoResults = true;
              return;
            }
            this.searchResults = searchResults.map((result) => {
              var status = this.appConfig
                .getStatusList()
                .filter((x) => {
                  return x.id === result.StatusID;
                })
                .pop();
              result.className = status ? status.styleClass : '';
              result.StatusDescription = status
                ? status.label
                : result.StatusID === 100
                  ? this.translate.instant('bikeshop.statuses.cancelled')
                  : '';
              return result;
            });

            console.log('Search results:', this.searchResults);
            if (this.searchResults.length === 0) {
              this.showNoResults = true;
            }

            // Check if we got fewer results than expected
            if (searchResults.length < 20) {
              this.hasMoreResults = false;
            }



            this.removeHighlight();
            await new Promise(resolve => setTimeout(resolve, 50));
            this.highlight();
          },
          (err) => {
            this.searching = false;
            this.searchResults = [];
            this.hasMoreResults = false;
          }
        );
      } catch (err) {
        this.searching = false;
        this.hasMoreResults = false;
      }
    }
  }

  updateSearch() {
    // Reset pagination when changing search criteria
    this.searchPage = 0;
    this.hasMoreResults = true;
    if (this.searchResults && this.searchResults.length > 0) {
      this.search();
    }
  }

  closeSearch() {
    this.showSearch = false;
    this.searchRequest = '';
    this.searchResults = [];
    this.searchPage = 0;
    this.hasMoreResults = true;
  }
}
